<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
    <path
      d="M11.8 8.8a3.42 3.42 0 1 0 0 6.84 3.42 3.42 0 0 0 0-6.84Zm-4.42 3.42a4.42 4.42 0 1 1 8.84 0 4.42 4.42 0 0 1-8.84 0Z"
    />
    <path
      d="M11.8 11.23a.98.98 0 1 0 0 1.97.98.98 0 0 0 0-1.97Zm-1.98.99a1.98 1.98 0 1 1 3.97 0 1.98 1.98 0 0 1-3.97 0Z"
    />
    <path
      d="M11.3 2.44a9.8 9.8 0 1 0 10.3 10.28h-2a7.8 7.8 0 1 1-8.3-8.27v-2Zm8.3 9.28a7.8 7.8 0 0 0-7.3-7.27v-2a9.8 9.8 0 0 1 9.3 9.27h-2Z"
    />
    <path d="M12.3 1.51c5.53.26 9.98 4.7 10.24 10.2h-3.89A6.86 6.86 0 0 0 12.3 5.4V1.5Z" />
  </svg>
</template>
<script>
export default {};
</script>
